/* eslint-disable no-constant-condition */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable curly */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Toast from 'react-native-toast-message';
import { View } from 'react-native';
import { useSelector } from 'react-redux';
import { isWeb } from '@global/screens';
import Colors from '@global/colors';
import { parseDate } from '@global/helpers';
import Button from '@components/form/Button';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';
import * as Layout from '@components/screen/Layout';
import DefaultButtonAction from '@/screens/task-notification/components/DefaultButtonAction';
import RejectActivity from '@/screens/sales-activity/components/RejectActivity';
import TargetActivity from '@/screens/task-notification/components/TargetActivity';
import TargetCustomer from '@/screens/task-notification/components/TargetCustomer';
import TargetLoyaltyPoint from '@/screens/task-notification/components/TargetLoyaltyPoint';
import TargetSalesOrder from '@/screens/task-notification/components/TargetSalesOrder';
import PricelistDetailScreen from '@/screens/setting/pricelist/PricelistDetailScreen';
import TargetBudgetPocket from '@/screens/task-notification/components/TargetBudgetPocket';

import { showPopup } from '@/store/modal';
import useApi from '@/hooks/useApi';
import { MsB2b } from '@api/ms-b2b';
import { MsAccount } from '@api/ms-account';
import { MsOrder } from '@api/ms-order';
import { MsCatalog } from '@api/ms-catalog';

const defaultPhoto = require('@/assets/img/default/user-default.png');
const photoSize = 35;
const today = new Date();

const TaskNotificationDetailScreen = (props) => {
  const dispatch = useDispatch();
  const [isShowRejectActivity, setIsShowRejectActivity] = useState(false);
  const [detailType, setDetailType] = useState('activities');
  const [loyaltyType, setLoyaltyType] = useState('add');
  const [detailData, setDetailData] = useState({});
  const [detailCustomer, setDetailCustomer] = useState({});
  const [detailCustomerCluster, setDetailCustomerCluster] = useState({});
  const [detailActivity, setDetailActivity] = useState({});
  const [detailLoyalty, setDetailLoyalty] = useState({});
  const [detailSalesOrder, setDetailSalesOrder] = useState({});
  const [detailPriceRules, setDetailPriceRules] = useState({});
  const [detailBudgetPocket, setDetailBudgetPocket] = useState({});
  const [clusterPayload, setClusterPayload] = useState({
    average_purchase_amount: '',
    cluster: '',
  });

  const getTasks = useApi(MsB2b.getTasks);
  const getNotifications = useApi(MsB2b.getNotifications);
  const getActivitiesDetail = useApi(MsB2b.getActivitiesDetail);
  const getCustomerId = useApi(MsAccount.getCustomerId);
  const getCustomers = useApi(MsAccount.getCustomers);
  const getClusterByCustomerId = useApi(MsAccount.getClusterByCustomerId);
  const getLoyaltyTransactionDetail = useApi(MsOrder.getLoyaltyCustomers);
  const getSalesOrderDetail = useApi(MsOrder.getSalesOrderDetail);
  const getPriceRulesDetail = useApi(MsCatalog.getPriceRulesDetail);
  const getBudgetPocketDetail = useApi(MsOrder.getBudgetPocketDetail);

  const isTask =
    props?.route?.params?.isTask == 'true' ||
    props?.route?.params?.isTask == true;
  const auth = useSelector((state) => state.auth);

  // get sales order detail
  const getSalesOrder = async (id) => {
    const sales_order = await getSalesOrderDetail.request(id);
    if (sales_order?.data?.data && Object.keys(sales_order.data.data).length) {
      setDetailSalesOrder(sales_order.data.data);
    } else {
      setDetailSalesOrder({});
    }
  };

  // get price rules detail
  const getPriceRules = async (id) => {
    const price_rules = await getPriceRulesDetail.request(id);
    if (price_rules?.data?.data && Object.keys(price_rules.data.data).length) {
      setDetailPriceRules(price_rules.data.data);
    } else {
      setDetailPriceRules({});
    }
  };

  // get loyalty point detail
  const getLoyaltyPoint = (id, cus_id) => {
    Promise.all([
      getCustomers.request({
        params: {
          filter: { _id: cus_id },
          fields: 'loyalty_points',
        },
      }),
      getLoyaltyTransactionDetail.request({
        params: {
          filter: { _id: id },
        },
      }),
    ])
      .then(([cust, loyalty]) => {
        if (loyalty.data?.data?.length && cust.data?.data?.length) {
          setDetailLoyalty({
            ...loyalty.data.data[0],
            status: loyalty.data.data[0].state,
            loyalty_points: cust.data.data[0].loyalty_points?.count || 0,
          });
          if (loyalty.data.data[0].points > 0) {
            setLoyaltyType('add');
          } else {
            setLoyaltyType('deduct');
          }
        } else {
          setDetailLoyalty({});
        }
      })
      .catch((e) => {
        setDetailLoyalty({});
      });
  };

  // get customer detail
  const getCustomer = async (id) => {
    const customer = await getCustomerId.request(id);
    if (customer?.data?.data && Object.keys(customer.data.data).length) {
      setDetailCustomer(customer.data.data);
    } else {
      setDetailCustomer({});
    }
  };

  // get sales activity detail
  const getActivity = async (id) => {
    const activity = await getActivitiesDetail.request(id);
    if (activity?.data?.data && Object.keys(activity.data.data).length) {
      const activity_detail = activity.data.data;

      if (activity_detail && Object.keys(activity_detail).length) {
        if (activity_detail.customer) {
          if (activity_detail.activity_type == 'engage_potential_customers') {
            setDetailCustomer({ name: activity_detail.customer?.name });
          } else if (activity_detail.customer.id) {
            await getCustomer(activity_detail.customer.id);
          }
        }
      }

      setDetailActivity(activity_detail);
    } else {
      setDetailActivity({});
    }
  };

  // get customer cluster detail
  const getCustomerCluster = async (id, cluster_id) => {
    const customer_cluster = await getClusterByCustomerId.request(id, {
      params: { filter: { _id: cluster_id }, limit: 1 },
    });
    if (
      customer_cluster?.data?.data &&
      Object.keys(customer_cluster.data.data).length
    ) {
      const result = customer_cluster.data.data;
      if (result?.cluster?.id)
        setClusterPayload({
          ...clusterPayload,
          cluster: { id: result.cluster.id, name: result.cluster.name },
        });
      if (result?.average_purchase_amount)
        setClusterPayload({
          ...clusterPayload,
          average_purchase_amount: result.average_purchase_amount,
        });
      setDetailCustomerCluster(result);
    } else {
      setDetailCustomerCluster({});
    }
  };

  const getBudgetPocket = async (id) => {
    try {
      const budget = await getBudgetPocketDetail.request(id);
      if (budget?.data?.data && Object.keys(budget.data.data).length) {
        const result = budget.data.data;
        result.periode = `${
          result.start_date ? parseDate(result.start_date) : '-'
        } - ${result.end_date ? parseDate(result.end_date) : '-'}`;
        result.last_updated = `${
          result.updated_at ? parseDate(result.updated_at) : '-'
        }`;
        result.status = result.current_status;
        setDetailBudgetPocket(result);
      } else {
        setDetailBudgetPocket({});
      }
    } catch (error) {}
  };

  // get detail task based on target type
  const getDetail = async (id) => {
    try {
      let response = null;
      if (isTask) {
        response = await getTasks.request({ params: { filter: { _id: id } } });
      } else {
        response = await getNotifications.request({
          params: { filter: { _id: id } },
        });
      }
      // console.log('response', response, id);
      if (response?.data?.data?.length) {
        const new_response = response.data.data[0];

        if (new_response && Object.keys(new_response).length) {
          if (new_response?.target?.id && new_response?.target?.entity) {
            const target_id = new_response.target.id;
            const target_type = new_response.target.entity;
            if (target_type == 'activities') {
              // if target type is activities (sales activity)
              setDetailType('activities');
              await getActivity(target_id);
            } else if (target_type == 'customers') {
              // if target type is customers
              setDetailType('customers');
              await getCustomer(target_id);
            } else if (target_type == 'loyalty_points') {
              // if target type is loyalty points
              setDetailType('loyalty_points');
              await getLoyaltyPoint(target_id, new_response.object.customer_id);
            } else if (target_type == 'orders') {
              // if target type is orders (sales order)
              setDetailType('orders');
              await getSalesOrder(target_id);
            } else if (target_type == 'price_rules') {
              // if target type is price rules
              setDetailType('price_rules');
              await getPriceRules(target_id);
            } else if (target_type == 'customers-clusters') {
              // if target type is customer clusters
              setDetailType('customers-clusters');
              await Promise.all([
                new_response?.object?.customer_id
                  ? getCustomer(new_response.object.customer_id)
                  : null,
                getCustomerCluster(new_response.object.customer_id, target_id),
              ]);
            } else if (target_type == 'budget-pockets') {
              setDetailType('budget-pockets');
              await getBudgetPocket(target_id);
            }
          }
        }

        setDetailData(new_response);
      } else {
        setDetailData({});
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setDetailSalesOrder({});
      setDetailLoyalty({});
      setDetailCustomer({});
      setDetailCustomerCluster({});
      setDetailActivity({});
      setDetailBudgetPocket({});
      setDetailData({});
      setDetailType('activities');
      setClusterPayload({
        average_purchase_amount: '',
        cluster: '',
      });
      if (props?.route?.params?.id) {
        getDetail(props.route.params.id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  // approve task
  const onApprove = async () => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      let response = null;
      if (detailType == 'activities') {
        // if target type is activities (sales activity)
        if (
          !detailActivity?.visited_at ||
          !detailActivity?.start_time ||
          !detailActivity?.end_time
        ) {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1:
              'This activities have no visit date or start time or end time.',
            type: 'error',
          });
          return false;
        }
        if (detailActivity?.visited_at && detailActivity?.end_time) {
          try {
            const split = detailActivity.end_time.split(':');
            const hour = Number(split[0]);
            const minute = Number(split[1]);
            const visited_date = new Date(detailActivity?.visited_at);
            visited_date.setHours(hour);
            visited_date.setMinutes(minute);
            if (visited_date.getTime() < today.getTime()) {
              dispatch(showPopup({ name: 'isLoading', value: false }));
              Toast.show({
                text1: 'This activities already overdue.',
                type: 'error',
              });
              return false;
            }
          } catch (error) {
            console.log(error);
          }
        }
        response = await MsB2b.updateSalesActivityStatus(
          detailActivity._id,
          'approved',
        );
      } else if (['customers', 'customers-clusters'].includes(detailType)) {
        // if target type is customers
        response = await MsAccount.updateCustomerStateById(
          detailCustomer._id,
          'approved',
        );
        // } else if (detailType == 'customers-clusters') {
        //   // if target type is customer cluster
        //   response = await MsAccount.updateCustomerClusterStatus(
        //     detailCustomer._id,
        //     detailCustomerCluster?.cluster?.id,
        //     'approved',
        //     clusterPayload,
        //   );
      } else if (detailType == 'loyalty_points') {
        // if target type is loyalty point
        response = await MsOrder.updateLoyaltyPointStatus(
          detailLoyalty._id,
          'approved',
        );
      } else if (detailType == 'orders') {
        // if target type is orders (sales order)
        response = await MsOrder.updateSalesOrderStatus(
          detailSalesOrder._id,
          'approved',
        );
      } else if (detailType == 'price_rules') {
        // if target type is prices rules
        response = await MsCatalog.updatePriceRulesStatus(
          detailPriceRules._id,
          'approved',
        );
      } else if (detailType == 'budget-pockets') {
        // if target type is budget pocket
        response = await MsOrder.changeStatusBudgetPocket(
          detailBudgetPocket._id,
          'approved',
        );
      }
      if (response?.data?.data && Object.keys(response.data.data).length) {
        getDetail(props.route.params.id);
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'Successfully processed data', type: 'success' });
      } else {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'A system error occurred', type: 'error' });
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({ text1: 'A system error occurred', type: 'error' });
    }
  };

  // reject task
  const onReject = async () => {
    if (detailType == 'activities') {
      // if target type is activities (sales activity) then show reject activity popup
      // response = await MsB2b.updateSalesActivityStatus(detailActivity._id, 'rejected')
      setIsShowRejectActivity(true);
    } else {
      dispatch(showPopup({ name: 'isLoading', value: true }));
      try {
        let response = null;
        if (['customers', 'customers-clusters'].includes(detailType)) {
          // if target type is customer
          response = await MsAccount.updateCustomerStateById(
            detailCustomer._id,
            'rejected',
            {
              reason: 'Customer rejected',
            },
          );
          // } else if (detailType == 'customers-clusters') {
          //   // if target type is customer cluster
          //   response = await MsAccount.updateCustomerClusterStatus(
          //     detailCustomer._id,
          //     detailCustomerCluster?.cluster?.id,
          //     'rejected',
          //     clusterPayload,
          //   );
        } else if (detailType == 'loyalty_points') {
          // if target type is loyalty point
          response = await MsOrder.updateLoyaltyPointStatus(
            detailLoyalty._id,
            'rejected',
          );
        } else if (detailType == 'orders') {
          // if target type is orders (sales order)
          response = await MsOrder.updateSalesOrderStatus(
            detailSalesOrder._id,
            'rejected',
          );
        } else if (detailType == 'price_rules') {
          // if target type is price rules
          response = await MsCatalog.updatePriceRulesStatus(
            detailPriceRules._id,
            'rejected',
          );
        } else if (detailType == 'budget-pockets') {
          // if target type is budget pocket
          response = await MsOrder.changeStatusBudgetPocket(
            detailBudgetPocket._id,
            'rejected',
          );
        }
        if (response?.data?.data && Object.keys(response.data.data).length) {
          getDetail(props.route.params.id);
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({ text1: 'Successfully processed data', type: 'success' });
        } else {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({ text1: 'A system error occurred', type: 'error' });
        }
      } catch (error) {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'A system error occurred', type: 'error' });
      }
    }
  };

  // if editing average purchase amount and cluster on customer cluster detail
  const onEdit = async () => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      let response = null;
      if (detailType == 'customers-clusters') {
        response = await MsAccount.updateCustomerCluster(
          detailCustomerCluster._id,
          clusterPayload,
        );
      }
      if (response?.data?.data && Object.keys(response.data.data).length) {
        getDetail(props.route.params.id);
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'Successfully updated data', type: 'success' });
      } else {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'A system error occurred', type: 'error' });
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({ text1: 'A system error occurred', type: 'error' });
    }
  };

  const isLoadingPage = () => {
    const loading = false;
    // if (detailType == 'activities') {
    //     loading = getActivitiesDetail.loading || getCustomerId.loading
    // } else if (detailType == 'customers') {
    //     loading = getCustomerId.loading
    // } else if (detailType == 'loyalty_points') {
    //     loading = getLoyaltyTransactionDetail.loading
    // } else if (detailType == 'orders') {
    //     loading = getSalesOrderDetail.loading
    // } else if (detailType == 'price_rules') {
    //     loading = getPriceRulesDetail.loading
    // }
    return isTask
      ? getTasks.loading || loading
      : getNotifications.loading || loading;
  };

  // show approval button
  const isShowButton = () => {
    let show = false;
    const userRole = auth?.user?.role?.code;
    if (userRole != 'salesman') {
      if (
        detailType == 'customers' &&
        detailCustomer?.status == 'need_approval'
      ) {
        // const listApprovals = detailCustomer?.approvals;
        // if (listApprovals?.length) {
        //   show = Boolean(listApprovals.find((x) => x.id === auth.userId));
        // } else {
        //   show = false;
        // }
        const listApprovals = detailCustomer?.approvals;
        if (listApprovals?.length) {
          show = Boolean(
            detailCustomer?.current_approval == userRole &&
              listApprovals?.find(
                (a) => a.id == auth.userId || a.role == userRole,
              ),
          );
          // const userApproval = detailCustomer?.approvals;
          // const hasAccessApproval = userApproval?.find(
          //   (ap) => ap.id == auth.userId,
          // );

          // show =
          //   hasAccessApproval &&
          //   !listApprovals
          //     .filter((sh) => {
          //       return (
          //         parseDate(sh.changed_at, 'd MM yyyy H:i') >=
          //         parseDate(detailCustomer.updated_at, 'd MM yyyy H:i')
          //       );
          //     })
          //     .find(
          //       (x) => x.to_status.indexOf(`${auth?.user?.role?.code}_`) > -1,
          //     );
        } else {
          show = false;
        }
      } else if (
        detailType == 'customers-clusters' &&
        detailCustomerCluster.status == 'need_approval'
      ) {
        // const listApprovals = detailCustomerCluster?.approvals;
        // if (listApprovals?.length) {
        //   show = Boolean(listApprovals.find((x) => x.id === auth.userId));
        // } else {
        //   show = false;
        // }
        const listApprovals = detailCustomerCluster?.approvals;
        if (listApprovals?.length) {
          show = Boolean(
            detailCustomer?.current_cluster_approval == userRole &&
              listApprovals?.find(
                (a) => a.id == auth.userId || a.role == userRole,
              ),
          );

          // const userApproval = detailCustomerCluster?.approvals;
          // const hasAccessApproval = userApproval?.find(
          //   (ap) => ap.id == auth.userId,
          // );

          // show =
          //   hasAccessApproval &&
          //   !listApprovals
          //     .filter((sh) => {
          //       return (
          //         parseDate(sh.changed_at, 'd MM yyyy H:i') >=
          //         parseDate(detailCustomerCluster.updated_at, 'd MM yyyy H:i')
          //       );
          //     })
          //     .find(
          //       (x) => x.to_status.indexOf(`${auth?.user?.role?.code}_`) > -1,
          //     );
        } else {
          show = false;
        }
      } else if (
        detailType == 'activities' &&
        detailActivity.status == 'waiting_confirmation'
      ) {
        // if target type is activities (sales activity) and status is waiting confirmation
        // show = true;
        if (detailActivity?.current_approval) {
          show = Boolean(detailActivity?.current_approval == userRole);
        } else {
          show = false;
        }
      } else if (
        detailType == 'loyalty_points' &&
        detailLoyalty.status == 'need_approval'
      ) {
        // if target type is loyalty point and status is need approval
        show = true;
      } else if (
        detailType == 'orders' &&
        detailSalesOrder.status == 'need_approval'
      ) {
        // if target type is orders (sales order) and status is need approval
        show = true;
      } else if (
        detailType == 'price_rules' &&
        detailPriceRules.status == 'need_approval'
      ) {
        // if target type is price rules and status is need approval
        if (detailPriceRules?.current_approval) {
          show = Boolean(detailPriceRules?.current_approval == userRole);
        } else {
          show = false;
        }
      } else if (
        detailType == 'budget-pockets' &&
        detailBudgetPocket.current_status == 'need_approval'
      ) {
        // if target type is budget pocket and status is need approval
        if (detailBudgetPocket?.current_approval) {
          show = Boolean(detailBudgetPocket?.current_approval == userRole);
        } else {
          show = false;
        }
      }
    }
    return show;
  };

  let title_section = detailData && detailData.title ? detailData.title : '-';
  let sub_title = detailData && detailData.title ? detailData.title : '-';
  let photo_image = defaultPhoto;
  // handling title section, title page and photo customer
  if (detailType == 'customers') {
    title_section = 'Customer Registration';
    sub_title = detailCustomer?.name ? detailCustomer.name : '-';
    photo_image =
      (Array.isArray(detailCustomer?.image) &&
        detailCustomer?.image.length > 0) ||
      (detailCustomer?.image && !Array.isArray(detailCustomer?.image));
    detailCustomer?.image
      ? {
          uri: Array.isArray(detailCustomer?.image)
            ? detailCustomer[0]
            : detailCustomer?.image,
        }
      : defaultPhoto;
  } else if (detailType == 'customers-clusters') {
    title_section = 'Customer Cluster';
    sub_title = detailCustomer?.name ? detailCustomer.name : '-';
    photo_image =
      (Array.isArray(detailCustomer?.image) &&
        detailCustomer?.image.length > 0) ||
      (detailCustomer?.image && !Array.isArray(detailCustomer?.image));
    detailCustomer?.image
      ? {
          uri: Array.isArray(detailCustomer?.image)
            ? detailCustomer[0]
            : detailCustomer?.image,
        }
      : defaultPhoto;
  } else if (detailType == 'loyalty_points') {
    title_section = loyaltyType == 'add' ? 'Add Point' : 'Deduct Point';
  } else if (detailType == 'budget-pockets') {
    title_section = 'Budget Pocket';
  } else if (detailType == 'price_rules') {
    sub_title = `Pricelist ${
      detailPriceRules &&
      detailPriceRules.market_type &&
      detailPriceRules.market_type.code
        ? detailPriceRules.market_type.code
        : ''
    }`;
  } else if (detailType == 'activities') {
    photo_image =
      (Array.isArray(detailCustomer?.image) &&
        detailCustomer?.image.length > 0) ||
      (detailCustomer?.image && !Array.isArray(detailCustomer?.image));
    detailCustomer?.image
      ? {
          uri: Array.isArray(detailCustomer?.image)
            ? detailCustomer[0]
            : detailCustomer?.image,
        }
      : defaultPhoto;
    sub_title = detailCustomer?.name ? detailCustomer.name : '-';
    if (detailActivity?.activity_type == 'visiting_existing_customer') {
      title_section = `Visit - ${sub_title}`;
    } else if (detailActivity?.activity_type == 'invoice_collection') {
      title_section = `Invoice Collection - ${sub_title}`;
    } else if (detailActivity?.activity_type == 'engage_potential_customers') {
      title_section = `Engage Customer - ${sub_title}`;
    }
  }

  return (
    <Layout.Container>
      {isWeb ? (
        <Layout.Back
          title="Tasks"
          onCallback={() => {
            if (props.navigation.canGoBack()) {
              props.navigation.goBack();
            } else {
              props.navigation.navigate('TaskNotificationScreen', {
                task: true,
              });
            }
          }}
        />
      ) : (
        false
      )}
      {isWeb && !['orders', 'price_rules'].includes(detailType) ? (
        <Layout.Wrapper white={false}>
          <Layout.Title title={title_section}>
            {isWeb &&
            ['customers', 'customers-clusters'].includes(detailType) &&
            isShowButton() ? (
              <DefaultButtonAction
                style={{ width: 'auto', justifyContent: 'flex-end' }}
                onReject={() => onReject()}
                onApprove={() => onApprove()}
              />
            ) : (
              false
            )}
          </Layout.Title>
        </Layout.Wrapper>
      ) : (
        false
      )}
      <Layout.Wrapper rounded>
        {isLoadingPage() ? (
          <Layout.Loader />
        ) : (
          <>
            <Layout.ScrollViewRefresher
              isFullHeight
              hasFooter={!isWeb ? isShowButton() : false}
              noScroll={Boolean(detailType && detailType == 'price_rules')}
              onCallback={() => getDetail(props?.route?.params?.id)}>
              <View
                style={{
                  width: '100%',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent:
                    (!isWeb &&
                      ['orders', 'price_rules'].includes(detailType)) ||
                    detailType == 'customers-clusters'
                      ? 'space-between'
                      : 'flex-start',
                  padding: 20,
                }}>
                <View
                  style={{
                    width: !isWeb
                      ? '100%'
                      : ['orders', 'customers-clusters'].includes(detailType)
                      ? '70%'
                      : detailType == 'price_rules'
                      ? '55%'
                      : '100%',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}>
                  {detailActivity.activity_type !=
                    'engage_potential_customers' &&
                  !['loyalty_points', 'price_rules', 'budget-pockets'].includes(
                    detailType,
                  ) ? (
                    <View
                      style={{
                        borderRadius: photoSize,
                        backgroundColor: Colors.grey0,
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden',
                        width: photoSize,
                        height: photoSize,
                        marginRight: 20,
                      }}>
                      <Image
                        source={photo_image}
                        style={{ width: photoSize, height: photoSize }}
                        width={photoSize}
                        height={photoSize}
                        defaultSource={defaultPhoto}
                        isPhoto={true}
                      />
                    </View>
                  ) : (
                    false
                  )}
                  <SociollaText type="medium" style={{ fontSize: 16 }}>
                    {sub_title}
                  </SociollaText>
                </View>
                {isWeb && isShowButton() ? (
                  <>
                    {detailType == 'orders' ? (
                      <Button
                        rounded={true}
                        buttonStyle={{ width: 150 }}
                        title={
                          <SociollaText
                            type="bold"
                            style={{
                              fontSize: 14,
                              letterSpacing: 0.5,
                              color: Colors.white,
                            }}>
                            Confirm
                          </SociollaText>
                        }
                        onPress={() => onApprove()}
                      />
                    ) : detailType == 'price_rules' ? (
                      <DefaultButtonAction
                        style={{ width: 'auto', justifyContent: 'flex-end' }}
                        onReject={() => onReject()}
                        approveText="Approve"
                        onApprove={() => onApprove()}
                      />
                    ) : (
                      false
                    )}
                  </>
                ) : (
                  false
                )}
                {false &&
                isWeb &&
                detailType == 'customers-clusters' &&
                detailCustomerCluster?._id &&
                clusterPayload?.cluster?.id &&
                (clusterPayload?.average_purchase_amount ||
                  clusterPayload?.average_purchase_amount == 0) ? (
                  <Button
                    type="primary"
                    rounded={true}
                    buttonStyle={{ width: 100 }}
                    title={
                      <SociollaText
                        type="bold"
                        style={{
                          fontSize: 14,
                          letterSpacing: 0.5,
                          color: Colors.white,
                        }}>
                        Edit
                      </SociollaText>
                    }
                    onPress={() => onEdit()}
                  />
                ) : (
                  false
                )}
              </View>
              {detailType == 'activities' ? (
                // if target type is activities (sales activity)
                <TargetActivity
                  detailCustomer={detailCustomer}
                  detailActivity={detailActivity}
                />
              ) : detailType == 'customers' ? (
                // if target type is customer
                <TargetCustomer detailCustomer={detailCustomer} />
              ) : detailType == 'customers-clusters' ? (
                // if target type is customer cluster
                <TargetCustomer
                  detailCustomer={detailCustomer}
                  detailCustomerCluster={detailCustomerCluster}
                  payloadCluster={clusterPayload}
                  onChangePayload={(val) => setClusterPayload(val)}
                />
              ) : detailType == 'loyalty_points' ? (
                // if target type is loyalty point
                <TargetLoyaltyPoint
                  loyaltyType={loyaltyType}
                  detailLoyalty={detailLoyalty}
                />
              ) : detailType == 'orders' ? (
                // if target type is orders (sales order)
                <TargetSalesOrder detailSalesOrder={detailSalesOrder} />
              ) : detailType == 'price_rules' ? (
                // if target type is price rules
                <PricelistDetailScreen
                  detailPriceRules={detailPriceRules}
                  notification={true}
                />
              ) : detailType == 'budget-pockets' ? (
                // if target type is budget pocket
                <TargetBudgetPocket detailBudgetPocket={detailBudgetPocket} />
              ) : (
                // <TargetPricelist detailPriceRules={detailPriceRules} />
                false
              )}
              {!isWeb ? <Layout.Spacer space={80} /> : false}
            </Layout.ScrollViewRefresher>
            {(isWeb
              ? !['customers', 'customers-clusters', 'price_rules'].includes(
                  detailType,
                )
              : true) &&
            isShowButton() &&
            detailData?._id ? (
              <>
                {isWeb ? (
                  <View style={{ padding: 20 }}>
                    <DefaultButtonAction
                      onReject={() => onReject()}
                      onApprove={() => onApprove()}
                    />
                  </View>
                ) : (
                  <Layout.ButtonSticky
                    show={
                      props?.route?.name == 'TaskNotificationDetailScreen' &&
                      Boolean(detailData?._id)
                    }
                    route={props?.route}
                    buttons={[
                      {
                        component: (
                          <DefaultButtonAction
                            onReject={() => onReject()}
                            onApprove={() => onApprove()}
                          />
                        ),
                      },
                    ]}
                  />
                )}
              </>
            ) : (
              false
            )}
          </>
        )}
      </Layout.Wrapper>
      {detailType == 'activities' ? (
        // reject popup for rejection activities (sales activity)
        <RejectActivity
          id={detailActivity._id}
          show={isShowRejectActivity}
          onClose={() => setIsShowRejectActivity(false)}
          onSubmit={() => {
            setIsShowRejectActivity(false);
            getDetail(props.route.params.id);
            Toast.show({ text1: 'Activity rejected', type: 'success' });
          }}
        />
      ) : (
        false
      )}
    </Layout.Container>
  );
};

export default TaskNotificationDetailScreen;
